import { render, staticRenderFns } from "./FirstTimeTac.vue?vue&type=template&id=d58467c0&"
import script from "./FirstTimeTac.vue?vue&type=script&lang=js&"
export * from "./FirstTimeTac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports